import template from './flight-fare.html';
import {outOfPolicyStatusStyle} from '../../../../common/enum/out-of-policy-status-style';

const DIRECTIVE_NAME = AtcFlightFare.DIRECTIVE_NAME = 'ktAtcFlightFare';
export default function AtcFlightFare() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcFlightFareController,
        controllerAs: '$ctrl',
        scope: {
            fare: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function AtcFlightFareController(
    userService,
    atcFlightFareService,
    atcFlightsService,
    supplierService,
    moment,
    l10nService,
    $filter,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        getOutOfPolicyMessage,
        isBritishAirwaysFlightId,
        moment,
        fareInfo: null,
        getOutOfPolicyStatusStyle,
        l10nService,
        getFareDescription,
        getFareValue,
        confirmRebook,
        rebook,
     });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        initFareInfo();
        vm.benefits = atcFlightFareService.prepareBenefits(vm.fare.FareBenefits);
    }

    function initFareInfo() {
        atcFlightFareService.getFareType(vm.fare.FareType)
            .then((fareInfo) => Object.assign(vm, {fareInfo}));
    }

    function getOutOfPolicyMessage() {
        const status = vm.fare.OutOfPolicyStatus;
        const messages = vm.fare.OutOfPolicyMessages;
        if (!(status && messages)) {
            return '';
        }
        return messages.join('<br><br>');
    }

    function isBritishAirwaysFlightId() {
        return supplierService.isBritishAirwaysFlightId(vm.recommendation.Supplier);
    }

    function getOutOfPolicyStatusStyle(status) {
        return outOfPolicyStatusStyle(status);
    }

    function getFareDescription() {
        const displayBalance = vm.recommendation.IsRefundable ? vm.recommendation.FareBalance : (vm.recommendation.FareBalance + vm.recommendation.MarkDifference + vm.recommendation.ResidualValue);
        return `<div><table class="fare-price-details"><tbody>
            <tr><td>${l10nService.localize('Penalty')}:</td><td class="text-right">${$filter('atcCurrencyByCode')(vm.recommendation.Penalty, vm.rs.currencySign)}</td></tr>
            <tr><td>${l10nService.localize('Tax Difference')}:</td><td class="text-right">${$filter('atcCurrencyByCode')(vm.recommendation.TaxDifference, vm.rs.currencySign)}</td></tr>
            <tr><td>${l10nService.localize('Fare Balance')}:</td><td class="text-right">${$filter('atcCurrencyByCode')(displayBalance, vm.rs.currencySign)}</td></tr>
            ${(vm.recommendation.HandlingFee === 0 ? '' : `<tr><td>${l10nService.localize('Handling Fee')}:</td><td class="text-right">${$filter('atcCurrencyByCode')(vm.recommendation.HandlingFee, vm.rs.currencySign)}</td></tr>`)}            
            <tr><td>${l10nService.localize('Charge Difference')}:</td><td class="text-right">${$filter('atcCurrencyByCode')(vm.recommendation.TotalChargeDifference, vm.rs.currencySign)}</td></tr>
            </tbody></table></div>`;
    }

    function getFareValue() {
        return (vm.rs.currencySign + vm.recommendation.TotalChargeDifference);
    }

    function confirmRebook() {
        const modal = atcFlightsService.confirmationModal(
            'Confirmation required', 'Tickets will be modified. Are you sure you want to continue?',
             function() {
                rebook();
            });
        modal();
    }

    function rebook() {
        atcFlightFareService.rebook(vm.fare, vm.recommendation, vm.searchParameters, vm.selectedFlights);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-fare/flight-fare-component.js